export const STATUS_LABELS = {
  1: "Pré-postagem",
  2: "Coletado",
  3: "Postado",
  4: "Em trânsito",
  5: "Entregue",
  6: "Cancelado",
  7: "Saiu para entrega",
  8: "Aferido",
  9: "Encaminhado para UF destino",
  10: "Pendente",
  11: "Aguardando retirada",
  12: "Tentativa não efetuada",
  13: "Extraviado",
  14: "Averiguar falha na entrega",
  15: "Retornando ao remetente",
  16: "Entregue ao contratante",
  17: "Entrega programada",
  18: "Etiqueta expirada",
  19: "Objeto recebido em nosso CD",
};

export const OPEN_PRE_STATUS_OPTIONS = [1, 2, 8, 9, 10, 18];

export const PRE_STATUS_OPTIONS = [1, 2, 6, 8, 9, 10, 18];
export const POST_STATUS_OPTIONS = [3, 4, 5, 7, 11, 12, 13, 14, 15, 16, 17, 19];
export const ALL_STATUS_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

export const STATUS_GROUPS = [
  { key: "pre", label: "Pré-postagem", statuses: OPEN_PRE_STATUS_OPTIONS.map(String), icon: "el-icon-tickets", color: "#8f9dc0" },
  { key: "progress", label: "Em andamento", statuses: ["3", "4", "7", "17", "19"], icon: "el-icon-truck", color: "#22418d" },
  { key: "attention", label: "Precisa da sua atenção", statuses: ["11", "12", "13", "14", "15"], icon: "el-icon-warning-outline", color: "#e6a23c" },
  { key: "delivered", label: "Entregues", statuses: ["5", "16"], icon: "el-icon-circle-check", color: "#67c23a" },
  { key: "canceled", label: "Canceladas", statuses: ["6"], icon: "el-icon-circle-close", color: "#909399" },
];

export const MALHA_STATES = ["SP", "ES", "RS", "SC", "PR", "RJ", "MG", "GO", "DF", "BA", "SE", "PB", "AL", "PE", "CE", "RN", "TO"];

export function statusLabel(status) {
  return STATUS_LABELS[+status] || String(status || "");
}

// Reversa Consolidada (TASK-1808): depois do CD, o 7 é o motorista levando ao cliente.
// A lista não traz um flag de consolidada: vale o prefixo do nome do serviço. O recebido_cd
// (receivedCd) separa o 7 do motorista do 7 dos Correios, que vem antes da caixa postal.
const CONSOLIDATED_OUT_LABEL = "Objeto em rota de entrega";
const CONSOLIDATED_SERVICE_PREFIX = "REVERSA CONSOLIDADA";

export function rowStatusLabel(row) {
  const consolidated = String((row && row.service) || "").startsWith(CONSOLIDATED_SERVICE_PREFIX);
  if (row && +row.status === 7 && consolidated && row.receivedCd) return CONSOLIDATED_OUT_LABEL;
  return statusLabel(row && row.status);
}

export function statusTagType(status) {
  const value = +status;
  if (value === 5 || value === 16) return "success";
  if (value === 13) return "danger";
  if ([11, 12, 14, 15, 18].includes(value)) return "warning";
  if (value === 6) return "info";
  return "";
}

export function statusTagTypeByLabel(description) {
  const text = (description || "").trim().toLowerCase();
  const found = Object.keys(STATUS_LABELS).find((key) => STATUS_LABELS[key].toLowerCase() === text);
  return found ? statusTagType(found) : "info";
}
